import React, { useState } from "react";
import Button from "../controls/Button";
import cn from "classnames";
import InfoBox from "../boxes/InfoBox";
import SubmitError from "../form-fields/SubmitError";
import TextField from "../form-fields/TextField";
import { Field, FieldRenderProps } from "react-final-form";
import { t } from "../../i18n";

interface DependantsFieldProps {
  numberOfDependants: null | number;
}

const dependantsLimit = 5;

const DependantsField = ({ numberOfDependants }: DependantsFieldProps) => {
  const [isTextField, setTextField] = useState(numberOfDependants && numberOfDependants >= dependantsLimit + 1);
  const dependantsOptions = new Array(dependantsLimit + 1).fill(1).map((el, index) => ({ value: index }));

  return (
    <>
      <p className="mt-10 mb-5 font-semibold">
        {t("loan.additional_data.dependants")}
      </p>
      {isTextField ? (
        <TextField
          className="Form-field Form-field--280"
          id="number_of_dependants"
          name="numberOfDependants"
          min={0}
          max={100}
          type="number"
        />
      ) : (
        <Field
          name="numberOfDependants"
          render={(
            renderProps: FieldRenderProps<number | string>): React.ReactNode => {
            const { input, meta } = renderProps;
            return (
              <div>
                {dependantsOptions.map(({ value }, index) => (
                  <Button
                    className={cn("Button SelectionButton small rounded", { isSelected: value === input.value })}
                    key={index}
                    onClick={() => input.onChange(value)}
                  >
                    {value}
                  </Button>
                ))}
                <Button
                  className={cn("Button SelectionButton small rounded")}
                  onClick={() => setTextField(true)}
                >
                  ...
                </Button>
                <SubmitError errors={meta.submitError}/>
              </div>
            );
          }}
        />
      )}
      <InfoBox i18nKey="registration.tips.dependants"/>
    </>
  );
};

export default DependantsField;
